module.exports = __webpack_public_path__ + "static/media/ruler-triangle.b2361d9b.svg";